import React, { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { OptionalDataTestIdProp } from 'Shared/utils/props/dataTestIdProp';

export const Row: FC<
  React.HTMLAttributes<HTMLDivElement> & OptionalDataTestIdProp
> = ({ children, className, 'data-testid': dataTestId }) => {
  const rowClassName = classNames(styles.row, className);
  return (
    <div data-testid={dataTestId} className={rowClassName}>
      {children}
    </div>
  );
};
